import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const faqs = [{
  question: '¿Sirve si recién recibimos el diagnóstico?',
  answer: 'Sí. El Bono 1 (Kit SOS Primeros 7 Días) está diseñado exactamente para ese momento.'
}, {
  question: '¿Las recetas son para Argentina?',
  answer: '100%. Ingredientes de súper, sin tiendas especializadas caras.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Por email en menos de 5 minutos. PDF descargable para celular, tablet o impresión.'
}, {
  question: '¿Es complicado de cocinar?',
  answer: 'No. Paso a paso, ingredientes simples, sin técnicas difíciles.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días. Escribís a soportenuevonivel@gmail.com y te devolvemos todo.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 lg:py-24" data-id="element-34" data-mp="1kp1mhhueyptj">
      <div className="mx-auto max-w-3xl" data-id="element-35" data-mp="1pncx3usj94ct">
        <SectionHeading eyebrow="Dudas frecuentes" title="Preguntas frecuentes" data-id="element-36" data-mp="1pmbact25mtf9" />

        <ul className="mt-10 space-y-3" data-id="element-37" data-mp="1aor7pssqdac9">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-forest/12 bg-cream-card" data-id="element-38" data-mp="1fqgl3f3fe03i" data-mpi={i}>
                <h3 data-id="element-39" data-mp="16oqta85msz57">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-200 hover:bg-cream-deep/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-forest/40" data-id="element-40" data-mp="16pa474wv6n9q">
                    <span className="font-display text-lg leading-snug text-forest-dark" data-id="element-41" data-mp="2pnor6x71i4x6">
                      {faq.question}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.2,
                  ease: 'easeOut'
                }} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-forest/8 text-forest" aria-hidden="true" data-id="element-42" data-mp="2ku3pau2bsqsp">
                      <PlusIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-43" data-mp="33ng2gq66977h" />
                    </motion.span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-44" data-mp="2yp65qb4styjr">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} data-id="element-45" data-mp="2unsybwm25naq">
                      <p className="px-5 pb-5 leading-relaxed text-forest-dark/70" data-id="element-46" data-mp="2pm0do8sj2d2">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}